<template>
    <div>

        <!-- Modal Autorizaçào de Desconto -->
        <div class="modal fade" id="autEditarValorModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="info">
                    <div class="modal-header">
                        <h5 class="modal-title">Edição de Valor</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Novo Valor"
                                    type="money"
                                    required
                                    :validate="validate"
                                    v-model="info.valor" />
                            </div>
                        </div>
                        <hr>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <input
                                    placeholder="Login..."
                                    type="text"
                                    v-model="info.login"
                                    required
                                    :validate="validate"
                                    autocomplete="off"
                                    class="form form-control" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <input
                                    placeholder="Senha..."
                                    type="text"
                                    id="password"
                                    style="-webkit-text-security: disc;"
                                    required
                                    :validate="validate"
                                    v-model="info.senha"
                                    autocomplete="off"
                                    class="form form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit @click="atualizar()">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            info: null,
            validate: false,
            callback: null, 
        };
    },

    components: { 
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        abrir (callback) { 
            this.callback = callback;
            this.info = null; 
            this.validate = false;

            this.$nextTick(() => { 
                this.info = { 
                    login: "", 
                    senha: "", 
                    valor: 0,
                };

                $('#autEditarValorModal').modal('show');    
            });
        },

        fechar() { 
            $('#autEditarValorModal').modal('hide');
        },

        atualizar() { 
            this.$util.atualizar (this, {
                service: "atendimentos",
                func: "aut_valor",
                dados: this.info,
                callback: res => { 
                    console.log(res);

                    if ( res.valor ) { 
                        this.callback(res);
                    }
                },
                modal: 'autEditarValorModal',
            });
        },
    }
}
</script>